import React from "react";

import { useNavigate, useParams } from "react-router-dom";

import {

    GetById,

    Update

} from 'adminApi/FoodpackageApi/Foodpackage';

import { validateForm } from "utils/validation";

import { FoodPackageRules } from "validation/ValidationRules";

import Spinner from "Common/Globle/Spinner";

import EditFoodpackageForm from "./Components/EditFoodpackageForm";

import fields from "../json/FoodPackageFields.json";

import useFormChange from "Hooks/useFormChange";

import useFormSubmit from "Hooks/useFormSubmit";

import useFetchFormDataById from "Hooks/useFetchFormDataById";



const EditFoodpackage = () => {

    const navigate = useNavigate();

    const { id } = useParams();

    const { formdata } = fields;



    // Initialize form values from JSON fields

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});



    // Manage input change

    const { values, errors, handleChange, setValues } = useFormChange(

        initialValues,

        FoodPackageRules

    );



    // Fetch existing data by ID

    const { loading: loadingFetch } = useFetchFormDataById(

        id,

        formdata,

        GetById,

        setValues

    );



    // Form submit

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(

        async (formValues) => {

            const formData = new FormData();

            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));

            return await Update({ id, data: formData });

        },

        (vals) => {

            return validateForm(vals, FoodPackageRules)

        },

        () => navigate(-1),

        "Fool Type updated successfully"

    );



    return (

        <>

            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}

            <EditFoodpackageForm

                fields={formdata}

                values={values}

                errors={errors}

                handleChange={handleChange}

                handleSubmit={(e) => handleSubmit(e, values)}

                loading={loadingSubmit}

                title="Edit Food Package Detail"

            />

        </>

    );

};



export default EditFoodpackage;

